import React from 'react';
import { connect } from 'react-redux';
import * as schoolsActions from '../store/schools/actions';
import * as reducers from '../store/reducers';
import { objectToArray } from '../utilities';

import SectionHeader from 'Components/SectionHeader';
import Button from 'Components/Button';
import SectionGroup from 'Components/SectionGroup';
import CollectionList from 'Components/CollectionList';
import Loading from 'Components/Loading';

class SchoolsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageLoading: true,
      schoolsRequested: false,
      schools: null,
    };
  }

  setPageLoading(props) {
    if (
      !props.isFetchingSchools &&
      this.state.pageLoading &&
      this.state.schoolsRequested
    ) {
      this.setState({
        pageLoading: false,
      });
    }
  }

  requestSchools(props) {
    if (props.activeUser && !this.state.schoolsRequested) {
      this.setState({ schoolsRequested: true }, this.props.fetchAllSchools);
    }
  }

  componentDidMount() {
    this.requestSchools(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setPageLoading(nextProps);
    this.requestSchools(nextProps);
    if (nextProps.schools) {
      this.setState({ schools: objectToArray(nextProps.schools) });
    }
  }

  render() {
    const { pageLoading } = this.state;
    const { schools } = this.state;
    if (pageLoading) return <Loading />;
    return (
      <main className="Page__content">
        <SectionGroup>
          <SectionHeader title="All Schools" type="page-header" />
        </SectionGroup>
        {schools.length ? (
          <CollectionList items={schools} type="schools" />
        ) : null}
      </main>
    );
  }
}

const mapStateToProps = state => {
  return {
    schools: reducers.getAllSchools(state),
    isFetchingSchools: reducers.getIsFetchingSchools(state),
    activeUser: reducers.getActiveUser(state),
  };
};

export default connect(mapStateToProps, schoolsActions)(SchoolsPage);
